import { useMutation } from '@tanstack/react-query';

import { deleteRelocationPoint, postRelocationPoint } from 'api/relocationPoints';
import { queryClient } from 'providers/AppQueryClientProvider';

function useRelocationPointMutations() {
  const postRelocationPointMutation = useMutation({
    mutationFn: async (value: string) => await postRelocationPoint(value),
    onMutate: async (newRelocationPoint) => {
      await queryClient.cancelQueries({ queryKey: ['relocationPoints'] });
      const previousRelocationPoints = queryClient.getQueryData(['relocationPoints']);
      queryClient.setQueryData<string[]>(['relocationPoints'], (old) => [...(old || []), newRelocationPoint]);
      return { previousRelocationPoints };
    },
    onError: (err, newTodo, context) => {
      queryClient.setQueryData(['relocationPoints'], context?.previousRelocationPoints);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['relocationPoints'] });
    },
  });

  const deleteRelocationPointMutation = useMutation({
    mutationFn: async (value: string) => await deleteRelocationPoint(value),
    onMutate: async (deletedRelocationPoint) => {
      await queryClient.cancelQueries({ queryKey: ['relocationPoints'] });
      const previousRelocationPoints = queryClient.getQueryData(['relocationPoints']);
      queryClient.setQueryData<string[]>(['relocationPoints'], (old) => [
        ...(old || []).filter((v) => v !== deletedRelocationPoint),
      ]);
      return { previousRelocationPoints };
    },
    onError: (err, newTodo, context) => {
      queryClient.setQueryData(['relocationPoints'], context?.previousRelocationPoints);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['relocationPoints'] });
    },
  });

  return { postRelocationPointMutation, deleteRelocationPointMutation };
}

export { useRelocationPointMutations };
